// extracted by mini-css-extract-plugin
export var label = "_dj-5";
export var slideContainer = "_dj-0";
export var slider = "_dj-1";
export var sliderLg = "_dj-4";
export var sliderMd = "_dj-3";
export var sliderSm = "_dj-2";